<tl-wysiwyg-wrapper #animationRoot>
  <wvr-wysiwyg-component [skin]="skin" [initialValue]="initialValue" [emitSaveEvent]="emitEvent" [toolbar]="toolbar" [height]="height"></wvr-wysiwyg-component>
</tl-wysiwyg-wrapper>
